
import Recaptcha from "../components/shared/Recaptcha.vue";
import EntradaVisada from "../components/visar/EntradaVisada.vue";
import TarjetasVisar from "../components/visar/TarjetasVisar.vue";
import Vue from "vue";
import tarjeta from "@/components/visar/Tarjeta.vue";
import vhero from "@/components/shared/VHero.vue";
import moment from "moment";
import { getDeviceUuid } from "../services/deviceUuid.js";

export default Vue.extend({
  components: {
    tarjeta,
    vhero,
    TarjetasVisar,
    EntradaVisada,
    Recaptcha
  },
  mounted() {
    const DEVICEINFO = getDeviceUuid();
    this.visado.uuid = DEVICEINFO;

    this.$http
      .get("Perfil", {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`
        }
      })
      .then(res => (this.visado.idUser = res.data.id));

    this.$http
      .get("Registra", {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`
        }
      })
      .then(res => {
        if(res.data.tieneEntrada){
          this.visado.fechaEntada = res.data.fechaEntada;
          this.visado.notaEntrada = res.data.notaEntrada;
          this.visado.motivo = res.data.motivo;          
        }
        this.esCargado = true;
      }).catch(() => this.esCargado = true)

    setInterval(() => {
      if (this.visado.fechaEntada !== "") {
        const fecha = moment(this.visado.fechaEntada).fromNow();
        this.visado.haceHoras = fecha;
      }
    }, 500);
  },
  data() {
    return {
      fechaDatos: {
        months: "Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre".split(
          "_"
        ),
        monthsShort: "Enero._Feb._Mar_Abr._May_Jun_Jul._Ago_Sept._Oct._Nov._Dec.".split(
          "_"
        ),
        weekdays: "Domingo_Lunes_Martes_Miercoles_Jueves_Viernes_Sabado".split(
          "_"
        ),
        weekdaysShort: "Dom._Lun._Mar._Mier._Jue._Vier._Sab.".split("_"),
        weekdaysMin: "Do_Lu_Ma_Mi_Ju_Vi_Sa".split("_")
      },
      visado: {
        fechaEntada: "",
        fechaFinalizacion: "",
        motivo: "",
        porIp: false,
        haceHoras: "",
        notaEntrada: "",
        notaSalida: "",
        uuid: "",
        idUser: ""
      },
      recaptchaRequest: "",
      esCargado: false
    };
  },
  computed: {
    cogerFecha(): string {
      moment.locale("es");
      const fecha = moment().format("dddd DD [de] MMMM [del] YYYY");

      return fecha[0].toUpperCase() + fecha.slice(1);
    },
    tiempoTotal(): string {
      const fecha = moment(this.visado.fechaEntada).format("DD [a las] HH:mm");
      return fecha[0].toUpperCase() + fecha.slice(1);
    }
  },
  methods: {
    setKeyRecaptcha(key: string) {
      this.recaptchaRequest = key;
    }
  }
});
